import { MenuItem } from '@components/apps-menu/utils';
import { Box, Loader, Menu, Tooltip } from '@mantine/core';
import { NoImage } from '@assets/icons';
import { themeColors } from '@/theme/colors';
import React, { useRef, useState } from 'react';
import { useImageUrl } from '@/hooks/useImageUrl';

interface Props {
  links: MenuItem[];
}

const LinkItem = ({ item, index }: { item: MenuItem; index: number }) => {
  const iconUrl = useImageUrl(item.iconSrc || null);
  const isLoading = !!item.iconSrc && !iconUrl;
  const spanRef = useRef<HTMLSpanElement>(null);
  const [tooltipOpened, setTooltipOpened] = useState(false);

  const handleMouseEnter = () => {
    const el = spanRef.current;
    if (el) setTooltipOpened(el.scrollWidth > el.offsetWidth);
  };

  return (
    <Menu.Item
      key={index}
      component="a"
      href={item.url || undefined}
      fz={16}
      px="sm"
      my="4px"
      target="_blank"
      disabled={!item.url}
      styles={{ itemLabel: { minWidth: 0, overflow: 'hidden' } }}
      leftSection={
        isLoading ? (
          <Loader size={20} />
        ) : iconUrl ? (
          <Box
            component="img"
            src={iconUrl}
            w={24}
            h={24}
            style={{ objectFit: 'contain', flexShrink: 0 }}
          />
        ) : (
          <NoImage stroke={themeColors.brandGray[0]} />
        )
      }
    >
      <Tooltip
        label={item.label}
        opened={tooltipOpened}
        withinPortal
        zIndex={1003}
        withArrow
        multiline
        maw={240}
      >
        <span
          ref={spanRef}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={() => setTooltipOpened(false)}
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'block'
          }}
        >
          {item.label}
        </span>
      </Tooltip>
    </Menu.Item>
  );
};

const LinksDialog = (props: Props) => {
  return (
    <>
      {props.links
        .filter((item) => item.label)
        .map((item, index) => (
          <LinkItem key={index} item={item} index={index} />
        ))}
    </>
  );
};

export default LinksDialog;
